module.exports = __webpack_public_path__ + "img/SK.aa933317.jpg";